import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
} from "@mui/material";

const ConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel,
  cancelLabel,
  confirmColor,
  confirmVariant,
}) => {
  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="confirm-dialog-title"
      open={open}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="confirm-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{cancelLabel}</Button>
        <Button
          onClick={onConfirm}
          color={confirmColor}
          variant={confirmVariant}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmDialog.defaultProps = {
  title: "Are you sure?",
  message: "This action cannot be undone.",
  confirmLabel: "Yes, Confirm",
  cancelLabel: "No, Go Back",
  confirmColor: "error",
  confirmVariant: "contained",
};

ConfirmDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  confirmColor: PropTypes.string,
  confirmVariant: PropTypes.string,
};

export default ConfirmDialog;
